(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["form-builder"] && !Shopify.designMode) return;
  try {
    
  // Form Builder client behaviour. One submit handler per form does two
  // additive, fire-and-forget things when configured: capture Interactor context
  // and POST to a webhook (which also carries opt_in + customer_tags for
  // server-side customer creation). It never preventDefaults, so the native
  // contact email and every other action still happen. Attribution is read via
  // the shared window.bbReadLeadAttr() published by lead-attribution.liquid.
  (function () {
    // Fill this form's hidden attribution inputs from the shared cookie reader.
    function fillLeadAttribution(form) {
      var fields = form.querySelectorAll('input[data-lead-attr]');
      if (!fields.length) { return; }
      var attr = (typeof window.bbReadLeadAttr === 'function') ? window.bbReadLeadAttr() : {};
      fields.forEach(function (input) {
        var key = input.getAttribute('data-lead-attr');
        if (attr[key]) { input.value = attr[key]; }
      });
    }

    // Customer creation is NOT done client-side: Shopify's hCaptcha (strict
    // since Oct 2024) returns 400 to any background form_type=customer POST that
    // lacks a captcha token, so a fetch from here can never succeed. Instead the
    // webhook payload carries opt_in + customer_tags and the merchant's
    // Zapier/Pabbly flow creates the customer via a Create Customer step
    // (server-side, no captcha, failures visible in the automation's history).

    // POST the submission to a Zapier/Pabbly webhook as form-encoded fields.
    // no-cors avoids any CORS setup (the response is opaque and unread). Keys are
    // de-namespaced (contact[Name] -> Name) for clean mapping downstream.
    function handleWebhook(wrap, form, eventId) {
      var url = wrap.getAttribute('data-fb-webhook');
      if (!url) { return; }
      var params = new URLSearchParams();
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name) { return; }
        var t = (el.type || '').toLowerCase();
        if (t === 'submit' || t === 'button') { return; }
        // Whitelist: only merchant-defined contact[...] fields. Also drops the
        // internals Shopify injects (form_type, utf8, h-captcha-response).
        if (el.name.indexOf('contact[') !== 0) { return; }
        if (el.hasAttribute('data-lead-attr')) { return; } // attribution added below
        if (el.hasAttribute('data-fb-optin')) { return; }  // sent as opt_in below
        var key = el.name.replace(/^contact\[/, '').replace(/\]$/, '');
        params.append(key, el.value);
      });
      params.append('form_name', wrap.getAttribute('data-fb-name') || '');
      params.append('form_id', form.id || '');
      // Shared with the Meta Pixel Lead so a server-side CAPI Lead can dedupe.
      params.append('event_id', eventId || '');
      params.append('page_url', window.location.href);
      params.append('page_title', document.title);
      params.append('shop', window.location.host);
      params.append('submitted_at', new Date().toISOString());
      var optIn = form.querySelector('input[data-fb-optin]');
      params.append('opt_in', optIn ? String(optIn.checked) : 'n/a');
      // Tags for the automation's Create Customer step — read from the wrapper,
      // NOT the opt-in checkbox, so they flow even when the checkbox is hidden.
      // The automation should still filter on opt_in=true before creating.
      params.append('customer_tags', wrap.getAttribute('data-fb-tags') || '');
      // Always send every attribution key (empty when absent): Zapier/Pabbly map
      // fields from a sample request, so a consistent schema beats sparse keys.
      var attr = (typeof window.bbReadLeadAttr === 'function') ? window.bbReadLeadAttr() : {};
      ['lead_source', 'gclid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'landing_page', 'referrer'].forEach(function (k) {
        params.append(k, attr[k] || '');
      });
      // keepalive requests are capped at ~64KB per origin; warn loudly if a huge
      // submission risks being dropped (the native email still carries it all).
      if (params.toString().length > 60000) {
        console.warn('[form-builder] webhook payload is large and may exceed the 64KB keepalive limit');
      }
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, body: params })
          .catch(function (e) { console.warn('[form-builder] webhook POST failed', e); });
      } catch (e) {
        console.warn('[form-builder] webhook POST threw', e);
      }
    }

    // Stash the visitor-facing field values so the Interactor trigger can pass
    // them as context on the post-submit render — by then the form is empty, so
    // we must capture at submit time. sessionStorage survives the same-tab
    // POST+redirect.
    function handleInteractorContext(wrap, form) {
      if (!wrap.getAttribute('data-fb-interactor')) { return; }
      var lines = [];
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name) { return; }
        var t = (el.type || '').toLowerCase();
        if (t === 'submit' || t === 'button') { return; }
        // Whitelist: only merchant-defined contact[...] fields. Also drops the
        // internals Shopify injects (form_type, utf8, h-captcha-response).
        if (el.name.indexOf('contact[') !== 0) { return; }
        if (el.hasAttribute('data-lead-attr')) { return; } // exclude attribution
        var key = el.name.replace(/^contact\[/, '').replace(/\]$/, '');
        if (key === 'email') { key = 'Email'; }
        if (el.hasAttribute('data-fb-optin')) {
          lines.push(key + ': ' + (el.checked ? 'Yes' : 'No'));
          return;
        }
        if (el.value) { lines.push(key + ': ' + el.value); }
      });
      if (!lines.length) { return; }
      try {
        sessionStorage.setItem('fb_interactor_ctx', lines.join('\n'));
      } catch (e) {
        console.warn('[form-builder] could not store Interactor context', e);
      }
    }

    function setupForm(wrap) {
      var form = wrap.querySelector('form');
      // Per-form guard: safe against the theme editor re-running section JS.
      if (!form || form.dataset.fbInit) { return; }
      form.dataset.fbInit = '1';
      fillLeadAttribution(form);
      form.addEventListener('submit', function () {
        // Fire the side effects exactly once per submission. Shopify's hCaptcha
        // wireup intercepts the submit, injects its token and RE-SUBMITS the
        // form, so this handler runs a second time for a single user submission —
        // which was double-posting the webhook. The native contact submit is
        // never blocked; only our fire-and-forget effects are de-duplicated.
        if (form.dataset.fbSubmitted) { return; }
        form.dataset.fbSubmitted = '1';
        // One event ID per submission, shared by the Meta Pixel Lead (read on the
        // success render) and the webhook (event_id) for Pixel<->CAPI dedup.
        var eventId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : ('lead-' + Date.now() + '-' + Math.round(Math.random() * 1e9));
        try {
          sessionStorage.setItem('fb_event_id', eventId);
        } catch (e) {
          console.warn('[form-builder] could not store fb_event_id', e);
        }
        handleInteractorContext(wrap, form);
        handleWebhook(wrap, form, eventId);
        // Fail loud: consent was given but nothing downstream can act on it.
        var optIn = form.querySelector('input[data-fb-optin]');
        if (optIn && optIn.checked && !wrap.getAttribute('data-fb-webhook')) {
          console.warn('[form-builder] email opt-in ticked but no webhook is configured — customer will not be created. Enable "Send submissions to a webhook" and add a Create Customer step in your automation.');
        }
      });
    }

    function setupInteractorSuccessButton(button) {
      if (button.dataset.fbInit) { return; }
      button.dataset.fbInit = '1';
      button.addEventListener('click', function () {
        var tries = 0;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Opening...';

        function openWhenReady() {
          if (window.interactor && window.interactor.modal && typeof window.interactor.modal.open === 'function') {
            window.interactor.modal.open();
            button.disabled = false;
            button.textContent = originalText;
            return;
          }

          var customFab = document.getElementById('bella-interactor-fab');
          if (customFab && !customFab.classList.contains('is-hidden')) {
            customFab.click();
            button.disabled = false;
            button.textContent = originalText;
            return;
          }

          if (tries++ < 50) { // ~5s
            setTimeout(openWhenReady, 100);
            return;
          }

          button.disabled = false;
          button.textContent = originalText;
          console.warn('[form-builder] Interactor not ready; manual open failed');
        }

        openWhenReady();
      });
    }

    function init() {
      document.querySelectorAll('.form-builder').forEach(setupForm);
      document.querySelectorAll('[data-fb-open-interactor]').forEach(setupInteractorSuccessButton);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
